import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import { get } from "../../../../utils/api";

const API_BASE = "/scope3/fuelEnergyActivities";

const mapFuelEnergyDocumentRow = (item) => ({
  ...item,
  purchasedElectricityResoldQuantity:
    item?.purchasedElectricityForResale?.resoldQuantity ?? "",
});

const FuelEnergyActivitiesDocuments = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("");
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const handleToggle = (option, nextUrl) => {
    setSelectedOption(option);
    setUrl(nextUrl);
  };

  const fetchData = async () => {
    try {
      const queryParams = new URLSearchParams({
        page: String(page),
        limit: "10",
        facilityList: selectedFacility.join(","),
        search: searchQuery,
        startYear: String(fromDate.year),
        startMonth: String(fromDate.month),
        endYear: String(toDate.year),
        endMonth: String(toDate.month),
      });
      const response = await get(`${API_BASE}/documents?${queryParams}`);
      const rows = response?.data?.data || [];
      setData(rows.map(mapFuelEnergyDocumentRow));
      setTotalPages(response?.data?.totalPages || 1);
      setPage(response?.data?.currentPage || page);
    } catch (error) {
      console.error("Error fetching fuel and energy documents:", error);
      setData([]);
      setTotalPages(1);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility, searchQuery]);

  const headers = [
    { title: "Date", key: "createdAt" },
    { title: "Consumption Period", key: "consumptionPeriod" },
    {
      title: "Purchased Electricity Resold Quantity",
      key: "purchasedElectricityResoldQuantity",
    },
  ];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      <TopMenu
        heading="Fuel and Energy Related Activities"
        setDrawerFilterOpen={() => {}}
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedOption={selectedOption}
        handleToggle={handleToggle}
        filterApplied={false}
        toggleData={[]}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        selectedFacility={selectedFacility}
        setSelectedFacility={setSelectedFacility}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        fetchData={fetchData}
        disableSearch
      />

      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={(_event, newPage) => setPage(newPage)}
        headers={headers}
        columnWidth="18% 25% 42% 15%"
      />
    </MainDashboardLayout>
  );
};

export default FuelEnergyActivitiesDocuments;
